import React, { useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import CoinSwiper from "../../components/CoinSwiper";
import { CardLayout, Text, useWindowSize } from "../../modules/Dashboard";
import SwapMain from "../../modules/swap/components/SwapMain";
import Tabs from "../../components/layouts/Tab";
import NewDepositCoin from "../wallet/deposit/coin/NewDepositCoin";
import { ReactComponent as NexaImg } from '../../assets/images/trading-pro/nexa.svg'
import SwapHistoryWidget from "../transactions/components/transactionsTable/swap/SwapHistoryWidget";
import MobileModal from "../../components/layouts/MobileModal";
import { MOBILE_SIZE } from "../../core/constants/common";

const SwapPage = () => {
    const { width } = useWindowSize()
    const tabs = [
        { key: "swap", label: "swap", content: <SwapMain /> },
        { key: "deposit", label: "increase-balance", content: <NewDepositCoin /> },
    ];

    const [modal, setModal] = useState(true)

    return (
        <MainLayout>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mx-auto">

                <div className="lg:col-span-2">
                    <CardLayout className="px-3 md:px-5 py-2">
                        <Tabs tabs={tabs} useRouting tabClassName="w-full  !text-center !justify-center" />
                    </CardLayout>
                </div>

                <div>
                    <CardLayout className="h-full">
                        <SwapHistoryWidget />
                    </CardLayout>
                </div>
            </div>
        </MainLayout>
    );
};

export default SwapPage;
